import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import ButtonBase from "@material-ui/core/ButtonBase";
import Toolbar from "@material-ui/core/Toolbar";
import OSSIcon from "../OSSIcon/OSSIcon";

const styles = theme => ({
  center: {
    display: "flex",
    alignItems: "center"
  },
  flex: {
    flex: 1
  },
  link: {
    display: "inline-flex"
  },
  betaTag: {
    margin: [[0, theme.spacing(1)]],
    padding: [[1, theme.spacing(1)]],
    border: `1px solid #a8a8a8`,
    fontSize: theme.typography.htmlFontSize,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold
  }
});

class OSSAppHeader extends React.Component {
  static Right = ({ children, classes }) => {
    return <React.Fragment>{children}</React.Fragment>;
  };

  render() {
    const { classes, ossLogoLinksToHome, user } = this.props;
    const currentEnvironment = window.location.hostname.split("-")[0];
    const currentPortalUrl = user?.apps?.filter(
      app =>
        app.name.toLowerCase().includes("access") &&
        app.url.includes(currentEnvironment)
    )[0];

    const handleGoToAccessPortal = () => {
      return (window.location.href = currentPortalUrl?.url
        ? currentPortalUrl.url
        : window.location.origin);
    };

    return (
      <AppBar elevation={0} position="static" color="inherit">
        <Toolbar>
          <div className={[classes.flex, classes.center].join(" ")}>
            {ossLogoLinksToHome ? (
              <ButtonBase
                onClick={handleGoToAccessPortal}
                className={classes.link}
              >
                <OSSIcon name="dvLogoPinnacle" />
              </ButtonBase>
            ) : (
              <OSSIcon name="dvLogoPinnacle" />
            )}
          </div>
          {React.Children.map(this.props.children, child =>
            React.cloneElement(child, { classes })
          )}
        </Toolbar>
      </AppBar>
    );
  }
}

OSSAppHeader.propTypes = {
  children: PropTypes.node,
  ossLogoLinksToHome: PropTypes.bool,
  user: PropTypes.any
};
OSSAppHeader.defaultProps = {
  children: <React.Fragment />,
  ossLogoLinksToHome: true,
  user: {}
};

export default withStyles(styles)(OSSAppHeader);
